import EnvironmentBanner from './EnvironmentBanner';

export default EnvironmentBanner;
